angular.module('qkr.partner.reports').controller('ViewPartnerReportsController',
    function PartnerReportsController($uibModal, $routeSegment, APP_CONSTANT) {
        const vm = this;

        vm.viewPartnerAccountancyReport = () => {
            let modalInstance;
            modalInstance = $uibModal.open({
                template: require('./finance1.html'),
                controller: 'PartnerFinance1ControllerModal as vm',
                windowClass: 'modal-huge',
                backdrop: 'static',
                resolve: {
                    reportInfo() {
                        return {reportType: APP_CONSTANT.FINANCE1_REPORT, report: null};
                    }
                }
            });
            modalInstance.result
                .then(() => $routeSegment.chain[1].reload())
                .catch(() => console.log('fail'));
        };
    }
);



// WEBPACK FOOTER //
// ./src/reports/partner/view/view.controller.js